export default {
  methods: {
    sortDirectionString(direction: -1 | 1): string {
      switch(direction) {
        case -1:
          return "desc";
        case 1:
          return "asc";
        default:
          return "desc";
      }
    },

    sortDirectionNum(directionString: "asc" | "desc"): number {
      switch(directionString) {
        case "desc":
          return -1;
        case "asc":
          return 1;
        default:
          return -1;
      }
    },

    reverseSort(direction: number | string): number | string {
      if (direction === 1 || direction === -1) {
        return -(direction);
      } else if (typeof direction === "string") {
        if (direction === "asc") {
          return "desc"
        } else {
          return "asc"
        }
      }
    }
  }
}